import React from 'react';
import VersionNumber from 'version';

export class PublicFooter extends React.Component<{}, {}> {
    public render() {
        return <div className='footer'>
            <div className='center-container'>
                <p>Rev. {VersionNumber}</p>
            </div>
        </div>;
    }
}
